export const resizeImageToSquare = async (file, size) => {
  const img = await loadImageFromFile(file);
  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;

  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Canvas not supported.');

  const minSide = Math.min(img.width, img.height);
  const sx = Math.floor((img.width - minSide) / 2);
  const sy = Math.floor((img.height - minSide) / 2);

  ctx.drawImage(img, sx, sy, minSide, minSide, 0, 0, size, size);

  return canvasToBlob(canvas, 'image/png');
};

export const resizeImageToMax = async (file, maxSize) => {
  const img = await loadImageFromFile(file);
  const maxDim = Math.max(img.width, img.height);
  const scale = Math.min(1, maxSize / maxDim);
  const width = Math.max(1, Math.round(img.width * scale));
  const height = Math.max(1, Math.round(img.height * scale));

  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;

  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Canvas not supported.');

  ctx.drawImage(img, 0, 0, width, height);

  return canvasToBlob(canvas, 'image/png');
};

export const cropImageToSquare = async (imageSrc, cropPixels, size) => {
  const img = await loadImageFromSource(imageSrc);
  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;

  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Canvas not supported.');

  ctx.drawImage(
    img,
    cropPixels.x,
    cropPixels.y,
    cropPixels.width,
    cropPixels.height,
    0,
    0,
    size,
    size
  );

  return canvasToBlob(canvas, 'image/png');
};

const loadImageFromFile = (file) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(file);
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = (err) => {
      URL.revokeObjectURL(url);
      reject(err);
    };
    img.src = url;
  });

const loadImageFromSource = (source) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = source;
  });

const canvasToBlob = (canvas, type) =>
  new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) {
          reject(new Error('Image processing failed.'));
          return;
        }
        resolve(blob);
      },
      type,
      0.92
    );
  });
